'use client';
import { useEffect } from 'react';

export const BviProvider = () => {
  useEffect(() => {
    let mounted = true;
    (async () => {
      if (typeof window === 'undefined') return;
      try {
        // Ensure stylesheet is present once
        const linkId = 'bvi-stylesheet';
        if (!document.getElementById(linkId)) {
          const link = document.createElement('link');
          link.id = linkId;
          link.rel = 'stylesheet';
          link.href = '/bvi/css/bvi.min.css';
          document.head.appendChild(link);
        }
        // Always start with regular version (clear only the activation cookie)
        document.cookie = `bvi_panelActive=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=${location.host}`;

        // Lazy-init plugin on first user click on any .bvi-open element
        const onFirstClick = async (event: MouseEvent) => {
          if (!mounted) return;
          const path = (event.composedPath && event.composedPath()) || [];
          const targetEl = (event.target as HTMLElement) || null;
          const candidate = (path.find((n) => n instanceof HTMLElement && (n as HTMLElement).classList?.contains('bvi-open')) ||
            (targetEl && targetEl.closest && targetEl.closest('.bvi-open'))) as HTMLElement | undefined | null;
          if (!candidate) return;
          event.preventDefault();
          // Prevent double init
          const win = window as unknown as {
            __BVI_INITED__?: boolean;
            isvek?: { Bvi?: new (opts: Record<string, unknown>) => unknown }
          };
          if (win.__BVI_INITED__) return;
          try {
            const mod: unknown = await import('@/libs/button-visually-impaired-javascript-master/dist/js/bvi.js');
            const maybeModule = mod as {
              default?: { Bvi?: new (opts: Record<string, unknown>) => unknown };
              Bvi?: new (opts: Record<string, unknown>) => unknown
            };
            const Bvi =
              maybeModule?.Bvi ||
              maybeModule?.default?.Bvi ||
              win.isvek?.Bvi;
            if (!Bvi) return;
            new Bvi({
              target: '.bvi-open',
              lang: 'ru-RU',
              panelFixed: true,
              panelHide: false,
              reload: false,
              images: 'grayscale',
            });
            win.__BVI_INITED__ = true;
            // Trigger the actual plugin click to enable the mode now that listeners are attached
            candidate.click();
            // After successful init, we can remove the global listener
            document.removeEventListener('click', onFirstClick, true);
          } catch {
            // no-op
          }
        };
        document.addEventListener('click', onFirstClick, true);
        // Cleanup on unmount
        return () => {
          document.removeEventListener('click', onFirstClick, true);
        };
      } catch {
        // no-op
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);
  return null;
};